import {ModuleWithProviders} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {TextComponent} from "./text.component";
import {ApiComponent} from "./api.component";
import {BadgeComponent} from "./badge.component";
import {ClassifierModule} from "./classifier.module";
import {HowtoComponent} from "./howto.component";

const routes: Routes = [
  {path: '', redirectTo: 'text', pathMatch: 'full'},
  { path: 'text', component: TextComponent},
  { path: 'api', component: ApiComponent},
  { path: 'how-to', component: HowtoComponent},
  { path: 'badge', component: BadgeComponent}
];

export const classifierRoutes: ModuleWithProviders<ClassifierModule> = RouterModule.forChild(routes);
